import loadable from '@loadable/component';
import React from 'react';
import {Text, View} from 'react-native';
import styles from './StepTitle.style';
const SVG = loadable(() => import('../../../../../imports/svg'));

export default function StepTitle(props) {
  const {
    icon,
    title,
    description,
    iconSize,
    titleStyle,
    descriptionStyle,
    countdown,
    countdownStyle,
  } = props;

  return (
    <>
      {!!icon && (
        <View style={styles.icon}>
          <SVG name={icon} width={iconSize ?? 30} height={iconSize ?? 30} />
        </View>
      )}
      {!!title && <Text style={[styles.title, titleStyle]}>{title}</Text>}
      {!!description && (
        <Text style={[styles.description, descriptionStyle]}>
          {description}
        </Text>
      )}
      {/* فقط وقتی countdown وجود داشته باشه */}
      {typeof countdown === 'string' && (
        <Text style={[styles.countdown, countdownStyle]}>{countdown}</Text>
      )}
    </>
  );
}
